module.exports = __webpack_public_path__ + "img/ordMoisturizing3.b2b93149.jpg";